import React, { Component } from 'react';

import './index.scss';

//assets
import advert from 'assets/mock/results-banner.png';
import close  from 'assets/icons/result_popup_close.svg';

class AdvertPopup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            animation_class: '',
            popup_id: this.props.popup_id
        }
        this.animateOut = this.animateOut.bind(this);
        this.animateIn  = this.animateIn.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if(props.popup_id !== state.popup_id) {
            return {animation_class: 'active'}
        }
        return {};
    }

    /* add class for animation after it is inserted into the DOM */
    componentDidMount() {
        this.animateIn();
    }

    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }

    /* first remove the active class for exit animation then call the callback */
    animateOut(callback) {
        this.setState({animation_class: ''});
        setTimeout(() => {
            if(callback) {
                callback(this.state.selected_id);
            }
            this.props.handleClose();
        }, 200);
    }

    render() {

        return (
            <div className = { "backdrop " + this.state.animation_class } onClick = { () => this.animateOut() }>
                <div className = {"ad popup_wrapper " + this.state.animation_class} onClick = { (e) => e.stopPropagation() }>
                    <div className = "popup_content">
                        <img className='close-img' src={close} alt='/' onClick = { () => this.animateOut() }/>
                        <img className='advert' src={advert} alt='/'/>
                    </div>
                </div>
            </div>
        )
    };
}

export default AdvertPopup;